import { jsx as Y, jsxs as Xt } from "react/jsx-runtime";
import * as z from "react";
import { useRef as qt, useState as $t, useCallback as pn, useEffect as Nt } from "react";
import { c as ht } from "../clsx-OuTLNxxd.js";
import { B as Yt } from "../Button-B2Q9lfS-.js";
import { c as Zt } from "../createLucideIcon-WU3cnAkb.js";
import '../Carousel.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gn = Zt("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hn = Zt("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
function yn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Kt(t) {
  return yn(t) || Array.isArray(t);
}
function Sn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Tt(t, n) {
  const r = Object.keys(t), o = Object.keys(n);
  if (r.length !== o.length) return !1;
  const i = JSON.stringify(Object.keys(t.breakpoints || {})), s = JSON.stringify(Object.keys(n.breakpoints || {}));
  return i !== s ? !1 : r.every((e) => {
    const u = t[e], c = n[e];
    return typeof u == "function" ? `${u}` == `${c}` : !Kt(u) || !Kt(c) ? u === c : Tt(u, c);
  });
}
function Ut(t) {
  return t.concat().sort((n, r) => n.name > r.name ? 1 : -1).map((n) => n.options);
}
function xn(t, n) {
  if (t.length !== n.length) return !1;
  const r = Ut(t), o = Ut(n);
  return r.every((i, s) => {
    const e = o[s];
    return Tt(i, e);
  });
}
function _t(t) {
  return typeof t == "number";
}
function Pt(t) {
  return typeof t == "string";
}
function bt(t) {
  return typeof t == "boolean";
}
function Qt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function T(t) {
  return Math.abs(t);
}
function Dt(t) {
  return Math.sign(t);
}
function dt(t, n) {
  return T(t - n);
}
function bn(t, n) {
  if (t === 0 || n === 0 || T(t) <= T(n)) return 0;
  const r = dt(T(t), T(n));
  return T(r / t);
}
function Cn(t) {
  return Math.round(t * 100) / 100;
}
function mt(t) {
  return pt(t).map(Number);
}
function H(t) {
  return t[yt(t)];
}
function yt(t) {
  return Math.max(0, t.length - 1);
}
function At(t, n) {
  return n === yt(t);
}
function Jt(t, n = 0) {
  return Array.from(Array(t), (r, o) => n + o);
}
function pt(t) {
  return Object.keys(t);
}
function Wt(t, n) {
  return [t, n].reduce((r, o) => (pt(o).forEach((i) => {
    const s = r[i], e = o[i], u = Qt(s) && Qt(e);
    r[i] = u ? Wt(s, e) : e;
  }), r), {});
}
function Ot(t, n) {
  return typeof n.MouseEvent < "u" && t instanceof n.MouseEvent;
}
function vn(t, n) {
  const r = {
    start: o,
    center: i,
    end: s
  };
  function o() {
    return 0;
  }
  function i(c) {
    return s(c) / 2;
  }
  function s(c) {
    return n - c;
  }
  function e(c, a) {
    return Pt(t) ? r[t](c) : t(n, c, a);
  }
  return {
    measure: e
  };
}
function gt() {
  let t = [];
  function n(i, s, e, u = {
    passive: !0
  }) {
    let c;
    if ("addEventListener" in i)
      i.addEventListener(s, e, u), c = () => i.removeEventListener(s, e, u);
    else {
      const a = i;
      a.addListener(e), c = () => a.removeListener(e);
    }
    return t.push(c), o;
  }
  function r() {
    t = t.filter((i) => i());
  }
  const o = {
    add: n,
    clear: r
  };
  return o;
}
function In(t, n, r, o) {
  const i = gt(), s = 1e3 / 60;
  let e = null, u = 0, c = 0;
  function a() {
    i.add(t, "visibilitychange", () => {
      t.hidden && d();
    });
  }
  function f() {
    S(), i.clear();
  }
  function m(h) {
    if (!c) return;
    e || (e = h, r(), r());
    const l = h - e;
    for (e = h, u += l; u >= s; )
      r(), u -= s;
    const y = u / s;
    o(y), c && (c = n.requestAnimationFrame(m));
  }
  function g() {
    c || (c = n.requestAnimationFrame(m));
  }
  function S() {
    n.cancelAnimationFrame(c), e = null, u = 0, c = 0;
  }
  function d() {
    e = null, u = 0;
  }
  return {
    init: a,
    destroy: f,
    start: g,
    stop: S,
    update: r,
    render: o
  };
}
function wn(t, n) {
  const r = n === "rtl", o = t === "y", i = o ? "y" : "x", s = o ? "x" : "y", e = !o && r ? -1 : 1, u = f(), c = m();
  function a(d) {
    const {
      height: p,
      width: h
    } = d;
    return o ? p : h;
  }
  function f() {
    return o ? "top" : r ? "right" : "left";
  }
  function m() {
    return o ? "bottom" : r ? "left" : "right";
  }
  function g(d) {
    return d * e;
  }
  return {
    scroll: i,
    cross: s,
    startEdge: u,
    endEdge: c,
    measureSize: a,
    direction: g
  };
}
function ot(t = 0, n = 0) {
  const r = T(t - n);
  function o(a) {
    return a < t;
  }
  function i(a) {
    return a > n;
  }
  function s(a) {
    return o(a) || i(a);
  }
  function e(a) {
    return s(a) ? o(a) ? t : n : a;
  }
  function u(a) {
    return r ? a - r * Math.ceil((a - n) / r) : a;
  }
  return {
    length: r,
    max: n,
    min: t,
    constrain: e,
    reachedAny: s,
    reachedMax: i,
    reachedMin: o,
    removeOffset: u
  };
}
function tn(t, n, r) {
  const {
    constrain: o
  } = ot(0, t), i = t + 1;
  let s = e(n);
  function e(g) {
    return r ? T((i + g) % i) : o(g);
  }
  function u() {
    return s;
  }
  function c(g) {
    return s = e(g), m;
  }
  function a(g) {
    return f().set(u() + g);
  }
  function f() {
    return tn(t, u(), r);
  }
  const m = {
    get: u,
    set: c,
    add: a,
    clone: f
  };
  return m;
}
function En(t, n, r, o, i, s, e, u, c, a, f, m, g, S, d, p, h, l, y) {
  const {
    cross: b,
    direction: C
  } = t, P = ["INPUT", "SELECT", "TEXTAREA"], w = {
    passive: !1
  }, v = gt(), I = gt(), E = ot(50, 225).constrain(S.measure(20)), D = {
    mouse: 300,
    touch: 400
  }, L = {
    mouse: 500,
    touch: 600
  }, M = d ? 43 : 25;
  let R = !1, j = 0, G = 0, tt = !1, Z = !1, K = !1, U = !1;
  function ct(x) {
    if (!y) return;
    function N(B) {
      (bt(y) || y(x, B)) && at(B);
    }
    const A = n;
    v.add(A, "dragstart", (B) => B.preventDefault(), w).add(A, "touchmove", () => {
    }, w).add(A, "touchend", () => {
    }).add(A, "touchstart", N).add(A, "mousedown", N).add(A, "touchcancel", V).add(A, "contextmenu", V).add(A, "click", J, !0);
  }
  function q() {
    v.clear(), I.clear();
  }
  function rt() {
    const x = U ? r : n;
    I.add(x, "touchmove", k, w).add(x, "touchend", V).add(x, "mousemove", k, w).add(x, "mouseup", V);
  }
  function st(x) {
    const N = x.nodeName || "";
    return P.includes(N);
  }
  function Q() {
    return (d ? L : D)[U ? "mouse" : "touch"];
  }
  function ut(x, N) {
    const A = m.add(Dt(x) * -1), B = f.byDistance(x, !d).distance;
    return d || T(x) < E ? B : h && N ? B * 0.5 : f.byIndex(A.get(), 0).distance;
  }
  function at(x) {
    const N = Ot(x, o);
    U = N, K = d && N && !x.buttons && R, R = dt(i.get(), e.get()) >= 2, !(N && x.button !== 0) && (st(x.target) || (tt = !0, s.pointerDown(x), a.useFriction(0).useDuration(0), i.set(e), rt(), j = s.readPoint(x), G = s.readPoint(x, b), g.emit("pointerDown")));
  }
  function k(x) {
    if (!Ot(x, o) && x.touches.length >= 2) return V(x);
    const A = s.readPoint(x), B = s.readPoint(x, b), $ = dt(A, j), X = dt(B, G);
    if (!Z && !U && (!x.cancelable || (Z = $ > X, !Z)))
      return V(x);
    const nt = s.pointerMove(x);
    $ > p && (K = !0), a.useFriction(0.3).useDuration(0.75), u.start(), i.add(C(nt)), x.preventDefault();
  }
  function V(x) {
    const A = f.byDistance(0, !1).index !== m.get(), B = s.pointerUp(x) * Q(), $ = ut(C(B), A), X = bn(B, $), nt = M - 10 * X, W = l + X / 50;
    Z = !1, tt = !1, I.clear(), a.useDuration(nt).useFriction(W), c.distance($, !d), U = !1, g.emit("pointerUp");
  }
  function J(x) {
    K && (x.stopPropagation(), x.preventDefault(), K = !1);
  }
  function F() {
    return tt;
  }
  return {
    init: ct,
    destroy: q,
    pointerDown: F
  };
}
function Ln(t, n) {
  let o, i;
  function s(m) {
    return m.timeStamp;
  }
  function e(m, g) {
    const d = `client${(g || t.scroll) === "x" ? "X" : "Y"}`;
    return (Ot(m, n) ? m : m.touches[0])[d];
  }
  function u(m) {
    return o = m, i = m, e(m);
  }
  function c(m) {
    const g = e(m) - e(i), S = s(m) - s(o) > 170;
    return i = m, S && (o = m), g;
  }
  function a(m) {
    if (!o || !i) return 0;
    const g = e(i) - e(o), S = s(m) - s(o), d = s(m) - s(i) > 170, p = g / S;
    return S && !d && T(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: u,
    pointerMove: c,
    pointerUp: a,
    readPoint: e
  };
}
function Nn() {
  function t(r) {
    const {
      offsetTop: o,
      offsetLeft: i,
      offsetWidth: s,
      offsetHeight: e
    } = r;
    return {
      top: o,
      right: i + s,
      bottom: o + e,
      left: i,
      width: s,
      height: e
    };
  }
  return {
    measure: t
  };
}
function Pn(t) {
  function n(o) {
    return t * (o / 100);
  }
  return {
    measure: n
  };
}
function On(t, n, r, o, i, s, e) {
  const u = [t].concat(o);
  let c, a, f = [], m = !1;
  function g(h) {
    return i.measureSize(e.measure(h));
  }
  function S(h) {
    if (!s) return;
    a = g(t), f = o.map(g);
    function l(y) {
      for (const b of y) {
        if (m) return;
        const C = b.target === t, P = o.indexOf(b.target), w = C ? a : f[P], v = g(C ? t : o[P]);
        if (T(v - w) >= 0.5) {
          h.reInit(), n.emit("resize");
          break;
        }
      }
    }
    c = new ResizeObserver((y) => {
      (bt(s) || s(h, y)) && l(y);
    }), r.requestAnimationFrame(() => {
      u.forEach((y) => c.observe(y));
    });
  }
  function d() {
    m = !0, c && c.disconnect();
  }
  return {
    init: S,
    destroy: d
  };
}
function Tn(t, n, r, o, i, s) {
  let e = 0, u = 0, c = i, a = s, f = t.get(), m = 0;
  function g() {
    const w = o.get() - t.get(), v = !c;
    let I = 0;
    return v ? (e = 0, r.set(o), t.set(o), I = w) : (r.set(t), e += w / c, e *= a, f += e, t.add(e), I = f - m), u = Dt(I), m = f, P;
  }
  function S() {
    const w = o.get() - n.get();
    return T(w) < 1e-3;
  }
  function d() {
    return c;
  }
  function p() {
    return u;
  }
  function h() {
    return e;
  }
  function l() {
    return b(i);
  }
  function y() {
    return C(s);
  }
  function b(w) {
    return c = w, P;
  }
  function C(w) {
    return a = w, P;
  }
  const P = {
    direction: p,
    duration: d,
    velocity: h,
    seek: g,
    settled: S,
    useBaseFriction: y,
    useBaseDuration: l,
    useFriction: C,
    useDuration: b
  };
  return P;
}
function _n(t, n, r, o, i) {
  const s = i.measure(10), e = i.measure(50), u = ot(0.1, 0.99);
  let c = !1;
  function a() {
    return !(c || !t.reachedAny(r.get()) || !t.reachedAny(n.get()));
  }
  function f(S) {
    if (!a()) return;
    const d = t.reachedMin(n.get()) ? "min" : "max", p = T(t[d] - n.get()), h = r.get() - n.get(), l = u.constrain(p / e);
    r.subtract(h * l), !S && T(h) < s && (r.set(t.constrain(r.get())), o.useDuration(25).useBaseFriction());
  }
  function m(S) {
    c = !S;
  }
  return {
    shouldConstrain: a,
    constrain: f,
    toggleActive: m
  };
}
function Dn(t, n, r, o, i) {
  const s = ot(-n + t, 0), e = m(), u = f(), c = g();
  function a(d, p) {
    return dt(d, p) <= 1;
  }
  function f() {
    const d = e[0], p = H(e), h = e.lastIndexOf(d), l = e.indexOf(p) + 1;
    return ot(h, l);
  }
  function m() {
    return r.map((d, p) => {
      const {
        min: h,
        max: l
      } = s, y = s.constrain(d), b = !p, C = At(r, p);
      return b ? l : C || a(h, y) ? h : a(l, y) ? l : y;
    }).map((d) => parseFloat(d.toFixed(3)));
  }
  function g() {
    if (n <= t + i) return [s.max];
    if (o === "keepSnaps") return e;
    const {
      min: d,
      max: p
    } = u;
    return e.slice(d, p);
  }
  return {
    snapsContained: c,
    scrollContainLimit: u
  };
}
function An(t, n, r) {
  const o = n[0], i = r ? o - t : H(n);
  return {
    limit: ot(i, o)
  };
}
function zn(t, n, r, o) {
  const s = n.min + 0.1, e = n.max + 0.1, {
    reachedMin: u,
    reachedMax: c
  } = ot(s, e);
  function a(g) {
    return g === 1 ? c(r.get()) : g === -1 ? u(r.get()) : !1;
  }
  function f(g) {
    if (!a(g)) return;
    const S = t * (g * -1);
    o.forEach((d) => d.add(S));
  }
  return {
    loop: f
  };
}
function Vn(t) {
  const {
    max: n,
    length: r
  } = t;
  function o(s) {
    const e = s - n;
    return r ? e / -r : 0;
  }
  return {
    get: o
  };
}
function Bn(t, n, r, o, i) {
  const {
    startEdge: s,
    endEdge: e
  } = t, {
    groupSlides: u
  } = i, c = m().map(n.measure), a = g(), f = S();
  function m() {
    return u(o).map((p) => H(p)[e] - p[0][s]).map(T);
  }
  function g() {
    return o.map((p) => r[s] - p[s]).map((p) => -T(p));
  }
  function S() {
    return u(a).map((p) => p[0]).map((p, h) => p + c[h]);
  }
  return {
    snaps: a,
    snapsAligned: f
  };
}
function Mn(t, n, r, o, i, s) {
  const {
    groupSlides: e
  } = i, {
    min: u,
    max: c
  } = o, a = f();
  function f() {
    const g = e(s), S = !t || n === "keepSnaps";
    return r.length === 1 ? [s] : S ? g : g.slice(u, c).map((d, p, h) => {
      const l = !p, y = At(h, p);
      if (l) {
        const b = H(h[0]) + 1;
        return Jt(b);
      }
      if (y) {
        const b = yt(s) - H(h)[0] + 1;
        return Jt(b, H(h)[0]);
      }
      return d;
    });
  }
  return {
    slideRegistry: a
  };
}
function kn(t, n, r, o, i) {
  const {
    reachedAny: s,
    removeOffset: e,
    constrain: u
  } = o;
  function c(d) {
    return d.concat().sort((p, h) => T(p) - T(h))[0];
  }
  function a(d) {
    const p = t ? e(d) : u(d), h = n.map((y, b) => ({
      diff: f(y - p, 0),
      index: b
    })).sort((y, b) => T(y.diff) - T(b.diff)), {
      index: l
    } = h[0];
    return {
      index: l,
      distance: p
    };
  }
  function f(d, p) {
    const h = [d, d + r, d - r];
    if (!t) return d;
    if (!p) return c(h);
    const l = h.filter((y) => Dt(y) === p);
    return l.length ? c(l) : H(h) - r;
  }
  function m(d, p) {
    const h = n[d] - i.get(), l = f(h, p);
    return {
      index: d,
      distance: l
    };
  }
  function g(d, p) {
    const h = i.get() + d, {
      index: l,
      distance: y
    } = a(h), b = !t && s(h);
    if (!p || b) return {
      index: l,
      distance: d
    };
    const C = n[l] - y, P = d + f(C, 0);
    return {
      index: l,
      distance: P
    };
  }
  return {
    byDistance: g,
    byIndex: m,
    shortcut: f
  };
}
function Fn(t, n, r, o, i, s, e) {
  function u(m) {
    const g = m.distance, S = m.index !== n.get();
    s.add(g), g && (o.duration() ? t.start() : (t.update(), t.render(1), t.update())), S && (r.set(n.get()), n.set(m.index), e.emit("select"));
  }
  function c(m, g) {
    const S = i.byDistance(m, g);
    u(S);
  }
  function a(m, g) {
    const S = n.clone().set(m), d = i.byIndex(S.get(), g);
    u(d);
  }
  return {
    distance: c,
    index: a
  };
}
function Hn(t, n, r, o, i, s, e, u) {
  const c = {
    passive: !0,
    capture: !0
  };
  let a = 0;
  function f(S) {
    if (!u) return;
    function d(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - a > 10) return;
      e.emit("slideFocusStart"), t.scrollLeft = 0;
      const y = r.findIndex((b) => b.includes(p));
      _t(y) && (i.useDuration(0), o.index(y, 0), e.emit("slideFocus"));
    }
    s.add(document, "keydown", m, !1), n.forEach((p, h) => {
      s.add(p, "focus", (l) => {
        (bt(u) || u(S, l)) && d(h);
      }, c);
    });
  }
  function m(S) {
    S.code === "Tab" && (a = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: f
  };
}
function ft(t) {
  let n = t;
  function r() {
    return n;
  }
  function o(c) {
    n = e(c);
  }
  function i(c) {
    n += e(c);
  }
  function s(c) {
    n -= e(c);
  }
  function e(c) {
    return _t(c) ? c : c.get();
  }
  return {
    get: r,
    set: o,
    add: i,
    subtract: s
  };
}
function nn(t, n) {
  const r = t.scroll === "x" ? e : u, o = n.style;
  let i = null, s = !1;
  function e(g) {
    return `translate3d(${g}px,0px,0px)`;
  }
  function u(g) {
    return `translate3d(0px,${g}px,0px)`;
  }
  function c(g) {
    if (s) return;
    const S = Cn(t.direction(g));
    S !== i && (o.transform = r(S), i = S);
  }
  function a(g) {
    s = !g;
  }
  function f() {
    s || (o.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: f,
    to: c,
    toggleActive: a
  };
}
function Rn(t, n, r, o, i, s, e, u, c) {
  const f = mt(i), m = mt(i).reverse(), g = l().concat(y());
  function S(v, I) {
    return v.reduce((E, D) => E - i[D], I);
  }
  function d(v, I) {
    return v.reduce((E, D) => S(E, I) > 0 ? E.concat([D]) : E, []);
  }
  function p(v) {
    return s.map((I, E) => ({
      start: I - o[E] + 0.5 + v,
      end: I + n - 0.5 + v
    }));
  }
  function h(v, I, E) {
    const D = p(I);
    return v.map((L) => {
      const M = E ? 0 : -r, R = E ? r : 0, j = E ? "end" : "start", G = D[L][j];
      return {
        index: L,
        loopPoint: G,
        slideLocation: ft(-1),
        translate: nn(t, c[L]),
        target: () => u.get() > G ? M : R
      };
    });
  }
  function l() {
    const v = e[0], I = d(m, v);
    return h(I, r, !1);
  }
  function y() {
    const v = n - e[0] - 1, I = d(f, v);
    return h(I, -r, !0);
  }
  function b() {
    return g.every(({
      index: v
    }) => {
      const I = f.filter((E) => E !== v);
      return S(I, n) <= 0.1;
    });
  }
  function C() {
    g.forEach((v) => {
      const {
        target: I,
        translate: E,
        slideLocation: D
      } = v, L = I();
      L !== D.get() && (E.to(L), D.set(L));
    });
  }
  function P() {
    g.forEach((v) => v.translate.clear());
  }
  return {
    canLoop: b,
    clear: P,
    loop: C,
    loopPoints: g
  };
}
function jn(t, n, r) {
  let o, i = !1;
  function s(c) {
    if (!r) return;
    function a(f) {
      for (const m of f)
        if (m.type === "childList") {
          c.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    o = new MutationObserver((f) => {
      i || (bt(r) || r(c, f)) && a(f);
    }), o.observe(t, {
      childList: !0
    });
  }
  function e() {
    o && o.disconnect(), i = !0;
  }
  return {
    init: s,
    destroy: e
  };
}
function Gn(t, n, r, o) {
  const i = {};
  let s = null, e = null, u, c = !1;
  function a() {
    u = new IntersectionObserver((d) => {
      c || (d.forEach((p) => {
        const h = n.indexOf(p.target);
        i[h] = p;
      }), s = null, e = null, r.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: o
    }), n.forEach((d) => u.observe(d));
  }
  function f() {
    u && u.disconnect(), c = !0;
  }
  function m(d) {
    return pt(i).reduce((p, h) => {
      const l = parseInt(h), {
        isIntersecting: y
      } = i[l];
      return (d && y || !d && !y) && p.push(l), p;
    }, []);
  }
  function g(d = !0) {
    if (d && s) return s;
    if (!d && e) return e;
    const p = m(d);
    return d && (s = p), d || (e = p), p;
  }
  return {
    init: a,
    destroy: f,
    get: g
  };
}
function qn(t, n, r, o, i, s) {
  const {
    measureSize: e,
    startEdge: u,
    endEdge: c
  } = t, a = r[0] && i, f = d(), m = p(), g = r.map(e), S = h();
  function d() {
    if (!a) return 0;
    const y = r[0];
    return T(n[u] - y[u]);
  }
  function p() {
    if (!a) return 0;
    const y = s.getComputedStyle(H(o));
    return parseFloat(y.getPropertyValue(`margin-${c}`));
  }
  function h() {
    return r.map((y, b, C) => {
      const P = !b, w = At(C, b);
      return P ? g[b] + f : w ? g[b] + m : C[b + 1][u] - y[u];
    }).map(T);
  }
  return {
    slideSizes: g,
    slideSizesWithGaps: S,
    startGap: f,
    endGap: m
  };
}
function $n(t, n, r, o, i, s, e, u, c) {
  const {
    startEdge: a,
    endEdge: f,
    direction: m
  } = t, g = _t(r);
  function S(l, y) {
    return mt(l).filter((b) => b % y === 0).map((b) => l.slice(b, b + y));
  }
  function d(l) {
    return l.length ? mt(l).reduce((y, b, C) => {
      const P = H(y) || 0, w = P === 0, v = b === yt(l), I = i[a] - s[P][a], E = i[a] - s[b][f], D = !o && w ? m(e) : 0, L = !o && v ? m(u) : 0, M = T(E - L - (I + D));
      return C && M > n + c && y.push(b), v && y.push(l.length), y;
    }, []).map((y, b, C) => {
      const P = Math.max(C[b - 1] || 0);
      return l.slice(P, y);
    }) : [];
  }
  function p(l) {
    return g ? S(l, r) : d(l);
  }
  return {
    groupSlides: p
  };
}
function Kn(t, n, r, o, i, s, e) {
  const {
    align: u,
    axis: c,
    direction: a,
    startIndex: f,
    loop: m,
    duration: g,
    dragFree: S,
    dragThreshold: d,
    inViewThreshold: p,
    slidesToScroll: h,
    skipSnaps: l,
    containScroll: y,
    watchResize: b,
    watchSlides: C,
    watchDrag: P,
    watchFocus: w
  } = s, v = 2, I = Nn(), E = I.measure(n), D = r.map(I.measure), L = wn(c, a), M = L.measureSize(E), R = Pn(M), j = vn(u, M), G = !m && !!y, tt = m || !!y, {
    slideSizes: Z,
    slideSizesWithGaps: K,
    startGap: U,
    endGap: ct
  } = qn(L, E, D, r, tt, i), q = $n(L, M, h, m, E, D, U, ct, v), {
    snaps: rt,
    snapsAligned: st
  } = Bn(L, j, E, D, q), Q = -H(rt) + H(K), {
    snapsContained: ut,
    scrollContainLimit: at
  } = Dn(M, Q, st, y, v), k = G ? ut : st, {
    limit: V
  } = An(Q, k, m), J = tn(yt(k), f, m), F = J.clone(), O = mt(r), x = ({
    dragHandler: it,
    scrollBody: Et,
    scrollBounds: Lt,
    options: {
      loop: St
    }
  }) => {
    St || Lt.constrain(it.pointerDown()), Et.seek();
  }, N = ({
    scrollBody: it,
    translate: Et,
    location: Lt,
    offsetLocation: St,
    previousLocation: sn,
    scrollLooper: cn,
    slideLooper: un,
    dragHandler: an,
    animation: ln,
    eventHandler: kt,
    scrollBounds: fn,
    options: {
      loop: Ft
    }
  }, Ht) => {
    const Rt = it.settled(), dn = !fn.shouldConstrain(), jt = Ft ? Rt : Rt && dn, Gt = jt && !an.pointerDown();
    Gt && ln.stop();
    const mn = Lt.get() * Ht + sn.get() * (1 - Ht);
    St.set(mn), Ft && (cn.loop(it.direction()), un.loop()), Et.to(St.get()), Gt && kt.emit("settle"), jt || kt.emit("scroll");
  }, A = In(o, i, () => x(wt), (it) => N(wt, it)), B = 0.68, $ = k[J.get()], X = ft($), nt = ft($), W = ft($), et = ft($), lt = Tn(X, W, nt, et, g, B), vt = kn(m, k, Q, V, et), It = Fn(A, J, F, lt, vt, et, e), Vt = Vn(V), Bt = gt(), on = Gn(n, r, e, p), {
    slideRegistry: Mt
  } = Mn(G, y, k, at, q, O), rn = Hn(t, r, Mt, It, lt, Bt, e, w), wt = {
    ownerDocument: o,
    ownerWindow: i,
    eventHandler: e,
    containerRect: E,
    slideRects: D,
    animation: A,
    axis: L,
    dragHandler: En(L, t, o, i, et, Ln(L, i), X, A, It, lt, vt, J, e, R, S, d, l, B, P),
    eventStore: Bt,
    percentOfView: R,
    index: J,
    indexPrevious: F,
    limit: V,
    location: X,
    offsetLocation: W,
    previousLocation: nt,
    options: s,
    resizeHandler: On(n, e, i, r, L, b, I),
    scrollBody: lt,
    scrollBounds: _n(V, W, et, lt, R),
    scrollLooper: zn(Q, V, W, [X, W, nt, et]),
    scrollProgress: Vt,
    scrollSnapList: k.map(Vt.get),
    scrollSnaps: k,
    scrollTarget: vt,
    scrollTo: It,
    slideLooper: Rn(L, M, Q, Z, K, rt, k, W, r),
    slideFocus: rn,
    slidesHandler: jn(n, e, C),
    slidesInView: on,
    slideIndexes: O,
    slideRegistry: Mt,
    slidesToScroll: q,
    target: et,
    translate: nn(L, n)
  };
  return wt;
}
function Un() {
  let t = {}, n;
  function r(a) {
    n = a;
  }
  function o(a) {
    return t[a] || [];
  }
  function i(a) {
    return o(a).forEach((f) => f(n, a)), c;
  }
  function s(a, f) {
    return t[a] = o(a).concat([f]), c;
  }
  function e(a, f) {
    return t[a] = o(a).filter((m) => m !== f), c;
  }
  function u() {
    t = {};
  }
  const c = {
    init: r,
    emit: i,
    off: e,
    on: s,
    clear: u
  };
  return c;
}
const Qn = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Jn(t) {
  function n(s, e) {
    return Wt(s, e || {});
  }
  function r(s) {
    const e = s.breakpoints || {}, u = pt(e).filter((c) => t.matchMedia(c).matches).map((c) => e[c]).reduce((c, a) => n(c, a), {});
    return n(s, u);
  }
  function o(s) {
    return s.map((e) => pt(e.breakpoints || {})).reduce((e, u) => e.concat(u), []).map(t.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: r,
    optionsMediaQueries: o
  };
}
function Xn(t) {
  let n = [];
  function r(s, e) {
    return n = e.filter(({
      options: u
    }) => t.optionsAtMedia(u).active !== !1), n.forEach((u) => u.init(s, t)), e.reduce((u, c) => Object.assign(u, {
      [c.name]: c
    }), {});
  }
  function o() {
    n = n.filter((s) => s.destroy());
  }
  return {
    init: r,
    destroy: o
  };
}
function xt(t, n, r) {
  const o = t.ownerDocument, i = o.defaultView, s = Jn(i), e = Xn(s), u = gt(), c = Un(), {
    mergeOptions: a,
    optionsAtMedia: f,
    optionsMediaQueries: m
  } = s, {
    on: g,
    off: S,
    emit: d
  } = c, p = L;
  let h = !1, l, y = a(Qn, xt.globalOptions), b = a(y), C = [], P, w, v;
  function I() {
    const {
      container: O,
      slides: x
    } = b;
    w = (Pt(O) ? t.querySelector(O) : O) || t.children[0];
    const A = Pt(x) ? w.querySelectorAll(x) : x;
    v = [].slice.call(A || w.children);
  }
  function E(O) {
    const x = Kn(t, w, v, o, i, O, c);
    if (O.loop && !x.slideLooper.canLoop()) {
      const N = Object.assign({}, O, {
        loop: !1
      });
      return E(N);
    }
    return x;
  }
  function D(O, x) {
    h || (y = a(y, O), b = f(y), C = x || C, I(), l = E(b), m([y, ...C.map(({
      options: N
    }) => N)]).forEach((N) => u.add(N, "change", L)), b.active && (l.translate.to(l.location.get()), l.animation.init(), l.slidesInView.init(), l.slideFocus.init(F), l.eventHandler.init(F), l.resizeHandler.init(F), l.slidesHandler.init(F), l.options.loop && l.slideLooper.loop(), w.offsetParent && v.length && l.dragHandler.init(F), P = e.init(F, C)));
  }
  function L(O, x) {
    const N = q();
    M(), D(a({
      startIndex: N
    }, O), x), c.emit("reInit");
  }
  function M() {
    l.dragHandler.destroy(), l.eventStore.clear(), l.translate.clear(), l.slideLooper.clear(), l.resizeHandler.destroy(), l.slidesHandler.destroy(), l.slidesInView.destroy(), l.animation.destroy(), e.destroy(), u.clear();
  }
  function R() {
    h || (h = !0, u.clear(), M(), c.emit("destroy"), c.clear());
  }
  function j(O, x, N) {
    !b.active || h || (l.scrollBody.useBaseFriction().useDuration(x === !0 ? 0 : b.duration), l.scrollTo.index(O, N || 0));
  }
  function G(O) {
    const x = l.index.add(1).get();
    j(x, O, -1);
  }
  function tt(O) {
    const x = l.index.add(-1).get();
    j(x, O, 1);
  }
  function Z() {
    return l.index.add(1).get() !== q();
  }
  function K() {
    return l.index.add(-1).get() !== q();
  }
  function U() {
    return l.scrollSnapList;
  }
  function ct() {
    return l.scrollProgress.get(l.offsetLocation.get());
  }
  function q() {
    return l.index.get();
  }
  function rt() {
    return l.indexPrevious.get();
  }
  function st() {
    return l.slidesInView.get();
  }
  function Q() {
    return l.slidesInView.get(!1);
  }
  function ut() {
    return P;
  }
  function at() {
    return l;
  }
  function k() {
    return t;
  }
  function V() {
    return w;
  }
  function J() {
    return v;
  }
  const F = {
    canScrollNext: Z,
    canScrollPrev: K,
    containerNode: V,
    internalEngine: at,
    destroy: R,
    off: S,
    on: g,
    emit: d,
    plugins: ut,
    previousScrollSnap: rt,
    reInit: p,
    rootNode: k,
    scrollNext: G,
    scrollPrev: tt,
    scrollProgress: ct,
    scrollSnapList: U,
    scrollTo: j,
    selectedScrollSnap: q,
    slideNodes: J,
    slidesInView: st,
    slidesNotInView: Q
  };
  return D(n, r), setTimeout(() => c.emit("init"), 0), F;
}
xt.globalOptions = void 0;
function zt(t = {}, n = []) {
  const r = qt(t), o = qt(n), [i, s] = $t(), [e, u] = $t(), c = pn(() => {
    i && i.reInit(r.current, o.current);
  }, [i]);
  return Nt(() => {
    Tt(r.current, t) || (r.current = t, c());
  }, [t, c]), Nt(() => {
    xn(o.current, n) || (o.current = n, c());
  }, [n, c]), Nt(() => {
    if (Sn() && e) {
      xt.globalOptions = zt.globalOptions;
      const a = xt(e, r.current, o.current);
      return s(a), () => a.destroy();
    } else
      s(void 0);
  }, [e, s]), [u, i];
}
zt.globalOptions = void 0;
const Yn = "_carousel_rwla9_1", Zn = "_carouselViewport_rwla9_5", Wn = "_carouselContainer_rwla9_9", te = "_carouselContainerHorizontal_rwla9_13", ne = "_carouselContainerVertical_rwla9_18", ee = "_carouselItem_rwla9_23", oe = "_carouselItemHorizontal_rwla9_30", re = "_carouselItemVertical_rwla9_34", se = "_carouselControl_rwla9_38", ie = "_carouselPreviousButtonHorizontal_rwla9_49", ce = "_carouselNextButtonHorizontal_rwla9_55", ue = "_carouselPreviousButtonVertical_rwla9_61", ae = "_carouselNextButtonVertical_rwla9_67", le = "_controlsOutside_rwla9_73", fe = "_carouselControlIcon_rwla9_86", de = "_srOnly_rwla9_91", _ = {
  carousel: Yn,
  carouselViewport: Zn,
  carouselContainer: Wn,
  carouselContainerHorizontal: te,
  carouselContainerVertical: ne,
  carouselItem: ee,
  carouselItemHorizontal: oe,
  carouselItemVertical: re,
  carouselControl: se,
  carouselPreviousButtonHorizontal: ie,
  carouselNextButtonHorizontal: ce,
  carouselPreviousButtonVertical: ue,
  carouselNextButtonVertical: ae,
  controlsOutside: le,
  carouselControlIcon: fe,
  srOnly: de
}, en = z.createContext(null);
function Ct() {
  const t = z.useContext(en);
  if (!t)
    throw new Error("useCarousel must be used within a <Carousel />");
  return t;
}
const me = z.forwardRef(
  ({ children: t, className: n, controlsPosition: r = "inside", opts: o, orientation: i = "horizontal", plugins: s, setApi: e, ...u }, c) => {
    const [a, f] = zt(
      {
        ...o,
        axis: i === "horizontal" ? "x" : "y"
      },
      s
    ), [m, g] = z.useState(!1), [S, d] = z.useState(!1), p = z.useCallback((C) => {
      C && (g(C.canScrollPrev()), d(C.canScrollNext()));
    }, []), h = z.useCallback(() => {
      f == null || f.scrollPrev();
    }, [f]), l = z.useCallback(() => {
      f == null || f.scrollNext();
    }, [f]), y = z.useCallback(
      (C) => {
        C.key === "ArrowLeft" ? (C.preventDefault(), h()) : C.key === "ArrowRight" && (C.preventDefault(), l());
      },
      [h, l]
    );
    z.useEffect(() => {
      !f || !e || e(f);
    }, [f, e]), z.useEffect(() => {
      if (f)
        return p(f), f.on("reInit", p), f.on("select", p), () => {
          f == null || f.off("reInit", p), f == null || f.off("select", p);
        };
    }, [f, p]);
    const b = z.useMemo(
      () => ({
        carouselRef: a,
        api: f,
        opts: o,
        orientation: i || ((o == null ? void 0 : o.axis) === "y" ? "vertical" : "horizontal"),
        scrollPrev: h,
        scrollNext: l,
        canScrollPrev: m,
        canScrollNext: S
      }),
      [a, f, o, i, h, l, m, S]
    );
    return /* @__PURE__ */ Y(en.Provider, { value: b, children: /* @__PURE__ */ Y(
      "div",
      {
        "aria-roledescription": "carousel",
        className: ht(_.carousel, r === "outside" && _.controlsOutside, n),
        "data-cxy-name": "carousel",
        onKeyDownCapture: y,
        ref: c,
        role: "region",
        ...u,
        children: t
      }
    ) });
  }
);
me.displayName = "Carousel";
const pe = z.forwardRef(
  ({ className: t, ...n }, r) => {
    const { carouselRef: o, orientation: i } = Ct();
    return /* @__PURE__ */ Y("div", { className: _.carouselViewport, ref: o, children: /* @__PURE__ */ Y(
      "div",
      {
        className: ht(
          _.carouselContainer,
          i === "horizontal" ? _.carouselContainerHorizontal : _.carouselContainerVertical,
          t
        ),
        ref: r,
        ...n
      }
    ) });
  }
);
pe.displayName = "CarouselContent";
const ge = z.forwardRef(
  ({ className: t, ...n }, r) => {
    const { orientation: o } = Ct();
    return /* @__PURE__ */ Y(
      "div",
      {
        "aria-roledescription": "slide",
        className: ht(
          _.carouselItem,
          o === "horizontal" ? _.carouselItemHorizontal : _.carouselItemVertical,
          t
        ),
        ref: r,
        role: "group",
        ...n
      }
    );
  }
);
ge.displayName = "CarouselItem";
const he = z.forwardRef(
  ({ className: t, size: n = "icon", variant: r = "outline", ...o }, i) => {
    const { canScrollPrev: s, orientation: e, scrollPrev: u } = Ct();
    return /* @__PURE__ */ Xt(
      Yt,
      {
        className: ht(
          _.carouselControl,
          _.carouselPreviousButton,
          e === "horizontal" ? _.carouselPreviousButtonHorizontal : _.carouselPreviousButtonVertical,
          t
        ),
        disabled: !s,
        onClick: u,
        ref: i,
        size: n,
        variant: r,
        ...o,
        children: [
          /* @__PURE__ */ Y(gn, { className: _.carouselControlIcon }),
          /* @__PURE__ */ Y("span", { className: _.srOnly, children: "Previous slide" })
        ]
      }
    );
  }
);
he.displayName = "CarouselPrevious";
const ye = z.forwardRef(
  ({ className: t, size: n = "icon", variant: r = "outline", ...o }, i) => {
    const { canScrollNext: s, orientation: e, scrollNext: u } = Ct();
    return /* @__PURE__ */ Xt(
      Yt,
      {
        className: ht(
          _.carouselControl,
          _.carouselNextButton,
          e === "horizontal" ? _.carouselNextButtonHorizontal : _.carouselNextButtonVertical,
          t
        ),
        disabled: !s,
        onClick: u,
        ref: i,
        size: n,
        variant: r,
        ...o,
        children: [
          /* @__PURE__ */ Y(hn, { className: _.carouselControlIcon }),
          /* @__PURE__ */ Y("span", { className: _.srOnly, children: "Next slide" })
        ]
      }
    );
  }
);
ye.displayName = "CarouselNext";
export {
  me as Carousel,
  pe as CarouselContent,
  ge as CarouselItem,
  ye as CarouselNext,
  he as CarouselPrevious
};
